import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ParentOrientationVideoModel } from '../../models/parentOrientationVideoModel';
import { AppConfig } from '../config';

@Injectable()
export class ParentOrientationVideosService {
  constructor(private http: HttpClient) { }

  getVideos(): Observable<ParentOrientationVideoModel[]> {
    return this.http.get<ParentOrientationVideoModel[]>(
      `${AppConfig.settings.apiServer.webApiURL}/ParentOrientationVideos`
    );
  }

  getPlayback(videoID: number): Observable<ParentOrientationVideoModel> {
    return this.http.get<ParentOrientationVideoModel>(
      `${AppConfig.settings.apiServer.webApiURL}/ParentOrientationVideos/${videoID}/playback`
    );
  }
}
